import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'
import DividerSection from '@segment/templates/DividerSection'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import ManagerConsumer from './components/ManagerConsumer'
import PrivacyPortal from './components/PrivacyPortal'
import StreamlineAccess from './components/StreamlineAccess'
import SegmentCommitment from './components/SegmentCommitment'

import ogImagePng from './assets/OgProductCcpa.png'

const CcpaView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Simple CCPA Compliance Solution | Twilio Segment"
        pageDescription="The California Consumer Privacy Act (CCPA) goes into effect on January 1, 2020. Honor consumer rights, like the right to deletion, with Twilio Segment's API and end-user privacy tools for CCPA."
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Hero />
        <Main>
          <ManagerConsumer />
          <DividerSection />
          <StreamlineAccess />
          <DividerSection />
          <PrivacyPortal />
          <SegmentCommitment />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  /* Give a main content a background color, so sections don't flash from white background */
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default CcpaView
